import UIFetchService from "../../Service/UIFetchService";
import qs from "qs";
import { DatasetRef } from "./model";

// 获取文件夹列表
export const getDirList = (data?: { id?: number; name?: string }) => {
  return UIFetchService.get(
    `/api/v1/querying_guide/templates/directories?${qs.stringify({
      type: "TEMPLATE",
      ...data,
    })}`
  );
};

// 更新文件夹列表
export const updateDir = (data: { id?: number; name: string }) => {
  return UIFetchService.post(
    "/api/v1/querying_guide/templates/directories",
    data
  );
};

// 删除文件夹
export const delDir = (id: number) => {
  return UIFetchService.delete(
    `/api/v1/querying_guide/templates/directory/${id}`
  );
};

// 获取数据集列表
export const getDataSetList = (
  data: {
    key?: string;
    ownsOnly?: boolean;
    sorter?: string;
  },
  sorter?: string
) => {
  return UIFetchService.get(
    `/api/v1/querying_guide/templates?${qs.stringify(data)}${
      sorter ? "&sorter=" + sorter : ""
    }`
  );
};

// 移动数据集
export const moveDataSet = (templateId: number, directoryId: number) => {
  return UIFetchService.method(
    "PATCH",
    `/api/v1/querying_guide/template/${templateId}/directory/${directoryId}`
  );
};

export const getDataSetRef = (id: number): Promise<DatasetRef> => {
  return UIFetchService.get(
    `/api/v1/querying_guide/templates/${id}/references`
  );
};

export const getFolderRef = (directoryId: number): Promise<DatasetRef> => {
  return UIFetchService.get(
    `/api/v1/querying_guide/templates/directory/${directoryId}/references`
  );
};
